import {
  AbstractControl,
  ValidatorFn
} from '@angular/forms';
import {
  CustomMinEqualDirective
} from './custom-forms-validations/custom-min-equal-validator.directive';
import {
  CustomMaxEqualDirective
} from './custom-forms-validations/custom-max-equal-validator.directive';

export class CustomValidations {

  /**
   * Directiva en formularios reactivos de evaluacion maxima en campos con separador de miles
   *
   * @static
   * @param {number} max
   * @param {string} [thousandsSeparator]
   * @param {string} [decimalSeparator]
   * @returns {ValidatorFn}
   * @memberof CustomValidations
   */
  static customMaxEqual(max: number, thousandsSeparator?: string, decimalSeparator?: string): ValidatorFn {
    return (control: AbstractControl) => {
      const cmevd = new CustomMaxEqualDirective();
      cmevd.customMaxEqual = max;
      if (thousandsSeparator) {
        cmevd.thousandsSeparator = thousandsSeparator;
      }
      if (decimalSeparator) {
        cmevd.decimalSeparator = decimalSeparator;
      }
      return cmevd.validate(control);
    };
  }
  /**
   * Directiva en formularios reactivos de evaluacion minima en campos con separador de miles
   *
   * @export
   * @param {number} min
   * @param {string} [thousandsSeparator]
   * @param {string} [decimalSeparator]
   * @returns {ValidatorFn}
   */
  static customMinEqual(min: number, thousandsSeparator?: string, decimalSeparator?: string): ValidatorFn {
    return (control: AbstractControl) => {
      const cmevd: CustomMinEqualDirective = new CustomMinEqualDirective();
      cmevd.customMinEqual = min;
      if (thousandsSeparator) {
        cmevd.thousandsSeparator = thousandsSeparator;
      }
      if (decimalSeparator) {
        cmevd.decimalSeparator = decimalSeparator;
      }
      return cmevd.validate(control);
    };
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/directives/custom-validactions.directive.ts